import { inject, Injectable } from '@angular/core';
import { HttpWithCacheService } from '../http-with-cache.service';
import { CedricApiService } from '../../infrastructure/api/cedric.api.service';
import { Observable } from 'rxjs';
import { EmailAddress } from '@aksia/models';

@Injectable({
  providedIn: 'root',
})
export class EmailAddressService extends HttpWithCacheService {
  private api = inject(CedricApiService);
  private controller: string = 'EmailAddress';

  constructor() {
    super();
  }

  geEmailAddresses(): Observable<EmailAddress[]> {
    return this.api.post(`${this.controller}/GetEmailAddresses`, {});
  }

  createEmailAddress(emailAddress: EmailAddress): Observable<any> {
    return this.api.post(`${this.controller}/CreateEmailAddress`, emailAddress);
  }

  updateEmailAddress(emailAddress: EmailAddress): Observable<any> {
    return this.api.post(`${this.controller}/UpdateEmailAddress`, emailAddress);
  }

  deleteEmailAddress(emailAddressId: number): Observable<any> {
    return this.api.post(`${this.controller}/DeleteEmailAddress`, {
      emailAddressId,
    });
  }
}
